module.exports = __webpack_public_path__ + "static/media/img-boxfit-thumb.d1fe444a.png";